module.exports = __webpack_public_path__ + "h5/img/noSearch.6912fb06.png";